/**
 * Initializes all custom accordions on the page.
 */
export const initAccordion = (): void => {
  const accordionContainers = document.querySelectorAll<HTMLElement>(
    "[data-accordion-container]"
  );

  if (accordionContainers.length === 0) {
    return;
  }

  accordionContainers.forEach((container) => {
    const accordionButtons = container.querySelectorAll<HTMLButtonElement>(
      "[data-accordion-button]"
    );

    accordionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const item = button.closest(".post-content-accordion__item");
        if (!item) return;

        // Optional: Close other open items if you want a traditional accordion
        // const parent = item.parentElement;
        // if (parent) {
        //   parent.querySelectorAll('.post-content-accordion__item.is-active').forEach(openItem => {
        //     if (openItem !== item) {
        //       openItem.classList.remove('is-active');
        //       openItem.querySelector<HTMLButtonElement>('[data-accordion-button]')?.setAttribute('aria-expanded', 'false');
        //     }
        //   });
        // }

        const isExpanded = item.classList.toggle("is-active");
        button.setAttribute("aria-expanded", String(isExpanded));
      });
    });
  });

  console.log("[Accordion] Initialized.");
};
